(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('HttpInterceptor', HttpInterceptor)
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('HttpInterceptor');
        });

    function HttpInterceptor($q, $window, $log, lodash, $location, $injector) {
        return {
            responseError: function(error) {
                if (error.status === 401) {
                    const DialogManager = $injector.get('DialogManager');
                    const PanelManager = $injector.get('PanelManager');
                    $q.when([
                        DialogManager.destroyAll(),
                        PanelManager.destroyAll()
                    ]).then(function() {
                        var redirect_destination = lodash.get(error, 'data.actions.redirect.destination', null);
                        if (!redirect_destination) {
                            $window.location.reload();
                        } else {
                            $location.path(error.data.actions.redirect.destination);
                        }
                        return $q.reject(error);
                    });
                } else {
                    console.log('responseError', error);
                    return $q.reject(error);
                }
            }
        }
    }
})();